import React from "react";
import styles            from "../../../../styles/mailCenter/shared.module.scss";
// import type { TabName } from "../constants";


// interface TabBarProps {
//   tabs:     TabName[];
//   active:   TabName;
//   onChange: (tab: TabName) => void;
// }

// export const TabBar: React.FC<TabBarProps> = ({ tabs, active, onChange }) => (
//   <div className={styles["tab-bar"]}>
//     {tabs.map((tab) => (
//       <button
//         key={tab}
//         onClick={() => onChange(tab)}
//         className={[
//           styles["tab-bar__item"],
//           active === tab ? styles["tab-bar__item--active"] : "",
//         ].join(" ")}
//       >
//         {tab}
//       </button>
//     ))}
//   </div>
// );

interface InputFieldProps {
  label?:       string;
  required?:    boolean;
  placeholder?: string;
  value:        string;
  onChange:     React.ChangeEventHandler<HTMLInputElement>;
  type?:        React.HTMLInputTypeAttribute;
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  required,
  placeholder,
  value,
  onChange,
  type = "text",
}) => (
  <div className={styles["input-field"]}>
    {label && (
      <label className={styles["input-field__label"]}>
        {label}{" "}
        {required && (
          <span className={styles["input-field__label-required"]}>*</span>
        )}
      </label>
    )}
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={styles["input-field__input"]}
    />
  </div>
);

interface SectionCardProps {
  children:   React.ReactNode;
  className?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  children,
  className = "",
}) => (
  <div className={`${styles["section-card"]} ${className}`}>{children}</div>
);


interface SectionTitleProps {
  children: React.ReactNode;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => (
  <h3 className={styles["section-title"]}>{children}</h3>
);